export default "__VITE_ASSET__BPkOBQWV__"